import { styled } from '@mui/material/styles';

export const ListContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  '& .row': {
    width: '100%',
    height: 70,
    borderRadius: 5,
    backgroundColor: theme.palette.action.disabledBackground,
    marginBottom: theme.spacing(1),
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.7,
    },

    '& .icon': {
      width: theme.spacing(5),
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.secondary.main,
    },

    '& .title': {},

    '& .score': {
      marginLeft: 'auto',
    },
  },
}));
